<div class="background">
	<div class="container">
		@if (mainCategories) {
			<div class="content-wrapper" fxLayout="row" fxLayout.xs="column">
				@if (viewport.isNotExtraSmall$ | async) {
					<g-sidenav
						fxFlex="200px"
						fxFlex.gt-sm="270px"
						[categories]="mainCategories"
						[allCategories]="allCategories"
					/>
				}

				<div fxLayout="column" class="category-content">
					@if (viewport.isExtraSmall$ | async) {
						<g-mobile-category-picker [categories]="mainCategories" [allCategories]="allCategories" />
					} @else {
						<g-category-header [categoryHeaderData]="categoryHeaderData$ | async" />
					}
					@if (!(categoryHeaderData$ | async)?.isEnabled) {
						<div class="category-basic-header">
							<h1>{{ getBasicHeader() }}</h1>
						</div>
					}
					<div class="tools" fxLayoutGap="30px" fxLayoutGap.lt-md="10px" #scrollToOnPageChange>
						<div class="tools-view">
							<button
								type="button"
								class="btn"
								[ngClass]="{ active: currentProductView === productView.Thumbnail }"
								(click)="setView(productView.Thumbnail)"
							>
								<g-icon [icon]="icons.faTableCellsLarge" />
							</button>
							<button
								type="button"
								class="btn"
								[ngClass]="{ active: currentProductView === productView.List }"
								(click)="setView(productView.List)"
							>
								<g-icon [icon]="icons.faList" />
							</button>
						</div>
						<div class="filter-options">
							<g-sorter
								data-cy="sort-select"
								[value]="sortBy?.column"
								[direction]="sortDirection"
								[sortOptions]="sortOptions"
								(onChange)="setSort($event)"
							/>
						</div>
						@if (currentProductView === productView.List && showPrices$ | async) {
							<g-vat-selector />
						}
					</div>
					<div class="pagination">
						<g-paginator
							[currentPage]="currentPage"
							[pageCount]="pageCount"
							(onChange)="onPageChange($event)"
						/>
					</div>
					@if (isLoading) {
						<g-loading-indicator />
					} @else if (currentProductView === productView.Thumbnail) {
						<g-product-list-thumbnail data-cy="product-list-thumbnail" [products]="filteredProducts$" />
					} @else if (currentProductView === productView.List) {
						<g-product-list-list data-cy="product-list-list" [products]="filteredProducts$" />
					}
					<div class="pagination">
						<g-paginator
							[currentPage]="currentPage"
							[pageCount]="pageCount"
							(onChange)="onPageChange($event)"
						/>
					</div>
				</div>
			</div>
		}
	</div>
</div>
